import React from "react";
import "./description.scss";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import Button from '../../atoms/button/button';

const Description = (props: ReferenciaContenido) => {

    const Bold = (children:any) => (
        <p className="a-description__text--bold">{children}</p>
     );
     
     const Text = (children:any) => (
        <p className="a-description__text">{children}</p>
     )
  
     const List = (children:any) => (
        <li className="a-description__list">{children}</li>
     )
     
     const options = {
        renderMark: {
           [MARKS.BOLD]: (text:any) => Bold(text)
        },
        renderNode: {
           [BLOCKS.LIST_ITEM]: (_node:any, children:any) => List(children),
           [BLOCKS.PARAGRAPH]: (_node:any, children:any) => Text(children)
        },
     };

	return (  
        <div className="a-description">
            {props.tituloGeneral ? <h2 className="a-description__title">{props.tituloGeneral}</h2> : null}
            {props.descripcion.json.content && documentToReactComponents(props.descripcion.json, options)}
            <div className="a-description__button">
                <Button
                    id='buttonDescription'
                    type='link'
                    href={props.redireccionBoton}
                    classname={'secondary '}
                    text={props.tituloBoton}
                    isDisabled={false}
                />
            </div>
        </div>
)}

export default Description
